import React, { useEffect, useState } from "react";
import API from "../lib/api";
import CandidateLayout from "./CandidateLayout";
import { useAppT, localizeStage, localizeResp } from "../components/home/i18n";
import { Clock } from "lucide-react";

const RESP_TONE = { candidate: "text-[#2E6B4B]", employer: "text-[#1F4A38]", admin: "text-[#8B3A3A]", authority: "text-[#b0722a]" };

function Timeline({ stages, current, a }) {
  return (
    <ol className="mt-3 space-y-2 border-l-2 border-[#E8E4DB] pl-4">
      {stages.map((s, i) => (
        <li key={i} className="relative">
          <span className={`absolute -left-[21px] top-1 h-3 w-3 rounded-full ${s.stage === current ? "bg-[#C4A46B]" : "bg-[#2E6B4B]"}`} />
          <div className="text-sm font-medium text-[#2C2A29]">{localizeStage(s.stage, a)} <span className={`ml-1 text-[11px] ${RESP_TONE[s.responsible] || "text-[#5C5855]"}`}>({localizeResp(s.responsible, a)})</span></div>
          {s.note && <div className="text-xs text-[#5C5855]">{s.note}</div>}
          <div className="text-[10px] text-[#8a8580]">{new Date(s.created_at).toLocaleString()}{s.due_date ? ` · ${a.common.due} ${s.due_date}` : ""}</div>
        </li>
      ))}
    </ol>
  );
}

export default function CandidateApplications() {
  const { a } = useAppT();
  const [apps, setApps] = useState([]);
  useEffect(() => { API.get("/candidate/applications").then(({ data }) => setApps(data.applications)); }, []);
  return (
    <CandidateLayout>
      <h1 className="font-serif text-3xl text-[#173A2C]">{a.candApps.title}</h1>
      <p className="mt-1 text-sm text-[#5C5855]">{a.candApps.sub}</p>
      <div className="mt-6 space-y-4" data-testid="applications-list">
        {apps.length === 0 && <div className="text-sm text-[#5C5855]">{a.candApps.empty}</div>}
        {apps.map((ap) => (
          <div key={ap.id} data-testid={`application-${ap.id}`} className="rounded-md border border-[#E8E4DB] bg-white p-5">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div className="font-serif text-xl text-[#173A2C]">{ap.job_title} <span className="text-sm text-[#5C5855]">· {ap.employer_org}</span></div>
              <span className="rounded-full bg-[#1F4A38] px-3 py-0.5 text-[11px] font-semibold text-white">{localizeStage(ap.current_stage, a)}</span>
            </div>
            <div className="mt-2 flex flex-wrap items-start gap-2 rounded-sm bg-[#FDFBF7] p-2 text-xs text-[#5C5855]">
              <Clock className="mt-0.5 h-3.5 w-3.5" /> {a.candApps.next} <b className="text-[#2C2A29]">{localizeResp(ap.responsible, a)}</b> — {ap.next_action}{ap.due_date ? ` · ${a.common.due} ${ap.due_date}` : ""} · {a.common.updated} {new Date(ap.last_update).toLocaleDateString()}
            </div>
            <Timeline stages={ap.stages} current={ap.current_stage} a={a} />
          </div>
        ))}
      </div>
    </CandidateLayout>
  );
}
